// file.reducer.ts
import { createReducer, on } from '@ngrx/store';
import * as PdfActions from './generate-pdf.actions';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { GeneratedPdfModel } from '../../models/pdf/generated-pdf.model';

export interface FileState extends EntityState<GeneratedPdfModel> {}

export const generatedFilesAdapter: EntityAdapter<GeneratedPdfModel> =
  createEntityAdapter<GeneratedPdfModel>();
export const initialState: FileState = generatedFilesAdapter.getInitialState();

export const pdfReducer = createReducer(
  initialState,
  on(PdfActions.pdfGenerated, (state, { payload }): FileState => {
    return generatedFilesAdapter.addOne(payload, state);
  }),
);
